var url = window.location.href;
        var productId = "";
        if (url.indexOf('/products/') != -1) {
        	productId = document.getElementById('product-box').getAttribute('product-id');
           document.getElementById('purchase').addEventListener('click', addClick, false);
        }
     function addClick() {
          push_add();
          document.getElementById('purchase').removeEventListener('click', addClick, false);
        }
       push_event("visit", productId, "", "");

        function push_add() {
        	var sku = "";
        	push_event("add", productId, sku, "");
        }

          function push_subscribe(email) {
        	push_event("subscribe", "", "", email);
        }

        function push_event(eventType, productId, sku, data) {
        	var clientName = 'w_client_id';
        	var clientId = getCookie(clientName);
        	if (clientId == null || clientId == '') {
        		clientId = Math.random().toString(36).slice(-11);
        		setCookie(clientName, clientId, 30);
        	}
          
            var cart_count = 0;var subtotal_price=0;;var token='';
            var cart = window.localStorage.getItem('added_to_cart');
            if (cart!=null && cart!='') {
              var cart_json = JSON.parse(cart);
              cart_count=  cart_json.item_count;
              subtotal_price =cart_json.items_subtotal_price;
              add_attributes(clientId,cart_json.attributes);
              token = getCookie("cart");
            }else{
              console.log("add attributes...");
               jQuery.post('/cart/update.js', { attributes: {'clientId': clientId} })
            }
        	var pageUrl = escape(window.location.href);
        	var pageTitle = escape(document.title);
        	var clientIp = getCookie('browserIp');
            var country=getCookie('localization');
        	var str = {
        		"clientId": clientId,
        		"eventType": eventType,
        		"pageUrl": pageUrl,
        		"pageTitle": pageTitle,
        		"clientIp": escape(clientIp),
                "country":country,
        		"productId": productId,
        		"sku": sku,
                "cartCount":cart_count,
                "subtotalPrice":subtotal_price,
                "cartToken":token,
        		"data": escape(data),
        		"random": Math.random().toString(36).slice(-8)
        	};
        	console.log(str);
        	var params = jsonToUrlParam(str);
        	var src = "http://dspv4.wantdo.com/dsp/f/tracing/event.gif?" + params;
        	// console.log("src:" + src)

        	var img = document.createElement("img");
        	img.setAttribute("rel", "nofollow");
        	img.setAttribute('class', 'CToWUd');
        	img.setAttribute('width', '0px');
        	img.setAttribute('height', '0px');
        	img.src = src;
        	document.body.appendChild(img);
        }
     function add_attributes(clientId,param) {
            // console.log("param:"+clientId);
            //   console.log(param);
            // console.log(param.clientId);
            var cart_attribute = param.clientId;
           if (cart_attribute == null || cart_attribute == '') {
              console.log("add attributes1...");
               jQuery.post('/cart/update.js', { attributes: {'clientId': clientId} })
            }
          }
      //查看购物车数据
       // var cartContents = fetch(window.Shopify.routes.root + 'cart.js')
       //    .then(response => response.json())
       //    .then(data => { 
       //       console.log('购物车');
       //      console.log(data);
       //    });
        function jsonToUrlParam(json) {
        	return Object.keys(json).map(key => key + '=' + json[key]).join('&');
        }

        function setCookie(name, value, days) {
        	var exp = new Date();
        	exp.setTime(exp.getTime() + (days * 24 * 60 * 60 * 1000));
        	document.cookie = name + "=" + escape(value) + ";expires=" + exp.toGMTString() + ";path=/";
        }

        function getCookie(cname) {
        	var name = cname + "=";
        	var ca = document.cookie.split(';');
        	for (var i = 0; i < ca.length; i++) {
        		var c = ca[i].trim();
        		if (c.indexOf(name) == 0) {
        			return c.substring(name.length, c.length);
        		}
        	}
        	return "";
        }
